var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":_vm.loadingImg}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }